import { styled } from "@mui/material";

export const Container = styled("div")({
  display: "inline-flex",
});
